import React from "react";
import styles from "./index.module.scss";
export function SupportEmail() {
    return (React.createElement("a", { className: styles.blue, href: "mailto:hello@predictmobile.com?subject=Predict Mobile Enquiry", target: "_blank" }, "hello@predictmobile.com"));
}
